import { render, staticRenderFns } from "./addressTitle.vue?vue&type=template&id=291a19f8&scoped=true&"
import script from "./addressTitle.vue?vue&type=script&lang=js&"
export * from "./addressTitle.vue?vue&type=script&lang=js&"
import style0 from "./addressTitle.vue?vue&type=style&index=0&id=291a19f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291a19f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('291a19f8')) {
      api.createRecord('291a19f8', component.options)
    } else {
      api.reload('291a19f8', component.options)
    }
    module.hot.accept("./addressTitle.vue?vue&type=template&id=291a19f8&scoped=true&", function () {
      api.rerender('291a19f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/conversion/addressTitle.vue"
export default component.exports